import { useContext } from 'react';
import { WalletContext } from '../context/WalletContext';
import { getAll, getEvents, positionId } from './getEvents';
import { totalLendBorrow } from './pooldata';
import { unilendV2poolABI } from '../../src/constants/abis';

const getAllContracts = async (poolAddress, V2poolABI, web3) => {
  const contract = new web3.eth.Contract(V2poolABI, poolAddress);
  return contract;
};

export const allLendBorrow = async (
  coreContract,
  unilendV2poolABI,
  event,
  web3
) => {
  const data = await getEvents(coreContract, 'PoolCreated');
  const newData = data.map((event) => event.returnValues.pool);
  let sum = 0;
  for (let i = 0; i < newData.length; i++) {
    const contract = await getAllContracts(newData[i], unilendV2poolABI, web3);
    const lend = await totalLendBorrow(contract, event, web3);
    sum += lend;
  }
 
  return sum;
};
//
export const allTransaction = async (
  coreContract,
  positionContract,
  userAddress,
  web3
) => {
  const data = await getEvents(coreContract, 'PoolCreated');
  // array of all pools address
  const newData = data.map((event) => event.returnValues.pool);
  let array = [];
  for (let i = 0; i < newData.length; i++) {
    const position = await positionId(
      positionContract,
      newData[i],
      userAddress
    );
    const poolContract = await getAllContracts(
      newData[i],
      unilendV2poolABI,
      web3
    );
    const eventNames = ['Borrow', 'Lend', 'Redeem', 'RepayBorrow'];
    for (let j = 0; j < eventNames.length; j++) {
     
      const events = await getAll(poolContract, eventNames[j], {
        _positionID: `${position}`,
      });
      array.push(...events);
   
    }
  }

  return array;
};

export const poolAvailable = async (coreContract, unilendV2poolABI, web3) => {
  const allLend = await allLendBorrow(
    coreContract,
    unilendV2poolABI,
    'Lend',
    web3
  );
  const allBorrow = await allLendBorrow(
    coreContract,
    unilendV2poolABI,
    'Borrow',
    web3
  );
 
  return allLend - allBorrow;
};

export const poolUtilizationRate = async (
  coreContract,
  unilendV2poolABI,
  web3
) => {
  const allLend = await allLendBorrow(
    coreContract,
    unilendV2poolABI,
    'Lend',
    web3
  );
  const allBorrow = await allLendBorrow(
    coreContract,
    unilendV2poolABI,
    'Borrow',
    web3
  );

  const utilization = (allBorrow / allLend) * 100;
  return utilization;
};
